import React, { createContext, useContext, useState } from 'react'
import { NotificationProps } from '~/components/header'

interface NotificationsContextValue {
  notifications: NotificationProps[]
  setNotifications: React.Dispatch<React.SetStateAction<NotificationProps[]>>
  countUnreadNotifications: number
  setCountUnreadNotifications: React.Dispatch<React.SetStateAction<number>>
}

const NotificationsContext = createContext<NotificationsContextValue | null>(null)

export const NotificationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notifications, setNotifications] = useState<NotificationProps[]>([])
  const [countUnreadNotifications, setCountUnreadNotifications] = useState<number>(0)

  return (
    <NotificationsContext.Provider
      value={{
        notifications,
        setNotifications,
        countUnreadNotifications,
        setCountUnreadNotifications,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  )
}

export default function useNotificationContext(): NotificationsContextValue {
  const notificationsContext = useContext(NotificationsContext)
  if (notificationsContext === null) {
    throw new Error('useNotificationContext must be used within a NotificationsProvider')
  }

  return notificationsContext
}
